import React from 'react';

/**
 * PageShell - Standard page wrapper with consistent header styling
 * Provides consistent page structure across admin pages
 */
export const PageShell = ({ 
  title, 
  subtitle, 
  actions, 
  children,
  className = '' 
}) => {
  return (
    <div className={`space-y-6 ${className}`}>
      {/* Page Header */}
      {(title || subtitle || actions) && (
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 pb-6 border-b border-gray-200">
          <div>
            {title && (
              <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-1">
                {title}
              </h1>
            )}
            {subtitle && (
              <p className="text-sm text-gray-600 mt-1">{subtitle}</p>
            )}
          </div>
          {actions && (
            <div className="flex flex-wrap items-center gap-3">
              {actions}
            </div>
          )}
        </div>
      )}
      
      {/* Page Content */}
      <div>
        {children}
      </div>
    </div>
  );
};

export default PageShell;
